export enum ParallaxBannerVariants {
  Primary = "primary",
  Neutral = "neutral",
  Light = "light",
}
